import React, { useEffect, useReducer, useState } from "react";
import get from 'lodash/get';
import { canUseDOM } from 'exenv';

let reducer = (info, newInfo) => {
  if (newInfo === null) {
    window.localStorage.removeItem("_jjdebug_global_settings");
    return initialState;
  }

  const { type, key, data } = newInfo;

  if(type ==='reset'){
    return Object.assign({}, info, {[key]: []});
  }

  if(type === 'append') {
    return Object.assign({}, info, {[key]: [...info[key], data]});
  }else{
    return { ...info, ...newInfo };
  }
};

const initialState = {
  activeTabs: ['page'], // Tabs to hide locally in debugger display
  pageVisits: [], // Global Page "Visits" by url
  sessionInfo: {}, // Page analytics for global storage session 
  sessionEvents: [], // Clicks, scrolls, and other DOM events
  darkMode: false,
  ufp: 'undetermined',
  isPersistent: true,
  pianoAid: undefined
};

const localState = JSON.parse(canUseDOM ? localStorage.getItem("_jjdebug_global_settings") : null);

const GlobalSettingsContext = React.createContext();


function GlobalSettingsProvider(props) {
  const [info, setInfo] = useReducer(reducer, localState || initialState);

  const getItem = (key, index) => {
    const localStorageObject = JSON.parse(localStorage.getItem("_jjdebug_global_settings"));
    if(typeof Array.isArray(key) && index) {
      // GET item from key at given index
      return get(localStorageObject, `[${key}][${index}]`, {});
    }else{
      return get(localStorageObject, `[${key}]`);
    }
  }

  const setItem = (key, data) => {
    const localStorageObject = JSON.parse(localStorage.getItem("_jjdebug_global_settings"));
    let updatedObject = Object.assign({}, localStorageObject, {[key]: data});
    setInfo(updatedObject);
  }

  const buildUserFingerprint = () => {
    const urlParams = new URLSearchParams(location.search);
    let ufp;
    // let ufp2= getItem('ufp');
    ufp = urlParams.get('ufp');

    if(ufp){
      setItem('ufp', ufp);
    }
  }

  if(info.ufp === 'undetermined'){
    buildUserFingerprint();
  }

  useEffect(() => {
    window.localStorage.setItem("_jjdebug_global_settings", JSON.stringify(info));
  }, [info]);


  const appendItem = (key, data) => {
    // const localStorageObject = JSON.parse(localStorage.getItem("_jjdebug_global_settings"));
    // localStorage.setItem(Object.assign({}, localStorageObject, {[key]: data}));
  }

  return (
    <GlobalSettingsContext.Provider
      value={{ 
        info,
        setInfo,
        getItem,
        setItem,
        appendItem,
      }}
    >
      {props.children}
    </GlobalSettingsContext.Provider>
  );
}

export { GlobalSettingsContext, GlobalSettingsProvider };
